import { render, staticRenderFns } from "./ProjectGroupKeywords.vue?vue&type=template&id=62cf9c57&lang=pug&"
import script from "./ProjectGroupKeywords.vue?vue&type=script&lang=js&"
export * from "./ProjectGroupKeywords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProjectGroupKeywords.vue"
export default component.exports